import React from 'react'
import PropTypes from 'prop-types'
import { getCurrencyParts, getAmountPlaceHolder } from '../../utility/formator'
import { addShake } from '../../utility/helper'
import { localsMessages } from '../../utility/getTemplateData'
import AmountValidationError from './amountValidationError.js';
import * as amountUtils from './amountUtils';
import { moveCursorToTheEnd } from '../../utility/domUtils';

let messages = localsMessages('common/amount');

class SingleAmount extends React.Component {
	constructor(props) {
		super(props);
		const [firstParts = {}] = getCurrencyParts();
		const { amount = '', symbol = '', code = '' } = this.props;
		const rightSymbol = firstParts.$ !== 'symbol';
		this.state = {
			amount, symbol, code, rightSymbol,
			placeholder: getAmountPlaceHolder(),
			inputWidth: amountUtils.MIN_INPUT_WIDTH,
			inputFontSize: amountUtils.DEFAULT_INPUT_FONTSIZE
		};
	}

	componentDidMount() {
		if (this.props.isEditable && this.singleAmountInput) {
			setTimeout(() => {
				this.singleAmountInput.focus();
				// Placeholder does not work good in IE
				// So call update to show value - 0.00(US)
				if (this.state.amount === '') {
					this.updateAmountField();					
				}
			}, 500)
		}
		this.inputResize();
	}

	handleFocus = (event) => {
		moveCursorToTheEnd(this.singleAmountInput);
		this.props.handleAmountFocus();
	}

	handleClick = (eventName) => {
		moveCursorToTheEnd(this.singleAmountInput);
	}

	handleKeyPress = (event) => {
		if (!amountUtils.isKeyAllowed(event.charCode)) {
			addShake()
			return;
		}
	}

	inputResize = () => {
		let inputWidth;

		try {
			 inputWidth = amountUtils.getInputWidth(this.singleAmountInput, this.state.amount);
		} catch (e) {
			inputWidth = amountUtils.MIN_INPUT_WIDTH;
		}
		// "Fixed" amount is rendered before the CSS is loaded and hence the
		// reported width is lesser than actual. Add a few pixels to fix that.
		if (!this.props.isEditable) {
			inputWidth += 20;
		}

		this.setState({
			inputWidth,
			inputFontSize: amountUtils.getFontSize(this.state.amount)
		})
	}

	handleChange = (event) => {
		let val = event.target.value;
		this.updateAmountField(val);
	}

	updateAmountField = (val) => {
		if (!amountUtils.amountLengthValid(val)) {
			addShake();
			return;
		}

		const stringValue = amountUtils.formatAmount(val, this.props.code);

		this.setState({ amount: stringValue }, () => {
			this.inputResize();
		});
		this.props.handleAmount(stringValue);
	}

	render() {
		const label = messages.amount && messages.amount.label || '';

		return (
			<div className="col-xs-12 col-sm-12 col-md-12 amount_holder">
				<div className="inputField" >
					<div className="money_input">
						{!this.state.rightSymbol && 	<div className="amount_currency">
														<span className="amount_currency_symbol"
															id="currencySymbol">{this.state.symbol}
														</span>
													</div>
						}
						<label htmlFor="currencyAmount" className="sr-only">{label}</label>
						<input
							type="text"
							readOnly={!this.props.isEditable}
							style={{
								width: this.state.inputWidth,
								fontSize: this.state.inputFontSize
							}}
							ref={(input) => (this.singleAmountInput = input)}
							name="donationAmount"
							autoComplete="off"
							id="currencyAmount"
							placeholder={this.state.placeholder}
							pattern="[0-9]*"
							value={this.state.amount}
							onKeyPress={this.handleKeyPress}
							onChange={this.handleChange}
							onClick={this.handleClick}
							onFocus={this.handleFocus}
							className="amount_number validate" />
						{this.state.rightSymbol && 	<div className="amount_currency">
														<span className="amount_currency_symbol"
															id="currencySymbol">{this.state.symbol}
														</span>
													</div>
						}
					</div>
				</div>
				<p className="text-center" id="currencyCode">{this.state.code}</p>
				{
					this.props.showValidationError &&
					<div className="vx_has-error-with-message text-center">
						<AmountValidationError
							errorString={this.props.validationErrorMessage}
							errorSourceField={'currencyAmount'}
							donationAmount={this.state.amount}
						/>
					</div>
				}
			</div>
		);
	}
}

SingleAmount.propTypes = {
	name: PropTypes.string,
	label: PropTypes.string,
	value: PropTypes.string,
	amount: PropTypes.string,
	symbol: PropTypes.string,
	code: PropTypes.string,
	decimalPoint: PropTypes.string,
	isEditable: PropTypes.bool,
	handleAmount: PropTypes.func,
	showValidationError: PropTypes.bool,
	validationErrorMessage: PropTypes.string,
	handleAmountFocus: PropTypes.func
};

export default SingleAmount



// WEBPACK FOOTER //
// ./components/amount/SingleAmount.js